import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Plan } from 'src/app/pages/virtual-class/interfaces';
import { BalanceService } from 'src/app/services/balance.service';

@Component({
  selector: 'app-plan-detail',
  templateUrl: './plan-detail.component.html',
  styleUrls: ['./plan-detail.component.scss'],
})
export class PlanDetailComponent implements OnInit {
  @Input() statement: Plan;

  constructor(
    private popoverController: PopoverController,
    public balanceSv: BalanceService
  ) {}

  ngOnInit() {}

  async close() {
    await this.popoverController.dismiss();
  }
}
